import { io } from 'socket.io-client';
import axios from 'axios';
import { API_BASE, SOCKET_URL } from './config';

let socket = null;

export function createTable() {
  return axios.post(`${API_BASE}/table`).then(r => r.data);
}

export function joinTable(tableID, name) {
  return axios.post(`${API_BASE}/table/${tableID}/join`, { name }).then(r => r.data);
}

export function rejoinTable(tableID, playerID) {
  return axios.get(`${API_BASE}/table/${tableID}/player/${playerID}`).then(r => r.data);
}

export function restoreTableSession(tableID, playerID, name, avatarUrl) {
  return axios
    .post(`${API_BASE}/table/${tableID}/rejoin`, { playerID, name, avatarUrl })
    .then(r => r.data);
}

export function connectSocket() {
  if (!socket) {
    socket = io(SOCKET_URL); // adjust as needed
  }
  return socket;
}
